import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=4f5d9d96&"
import script from "./TagInput.vue?vue&type=script&lang=js&"
export * from "./TagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5d9d96')) {
      api.createRecord('4f5d9d96', component.options)
    } else {
      api.reload('4f5d9d96', component.options)
    }
    module.hot.accept("./TagInput.vue?vue&type=template&id=4f5d9d96&", function () {
      api.rerender('4f5d9d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/TagInput.vue"
export default component.exports